import React, { useEffect, useState } from "react";
import { axios } from "../../../../Global";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PromptElement from "../../PromptElement";
import QuotationForm from "./QuotationForm";
import ListDataQuotation from "./ListDataQuotation";
import { printValidationError } from "../../../../utils/functions";
import { checkAccessFn } from "../../../../utils/checkAccess";
import ContractModalElement from "./ContractModalElement";
import { getQuotationData } from "../../../../store/Api";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import QuotationToContract from "./QuotationToContract";
import nodeinstance from "../../../../nodeInstance";

export default function Quotation() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const quotationData = useSelector((state) => state.quotationData);
  useEffect(() => {
    dispatch(getQuotationData(token));
  }, []);
  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
    id: null,
  });
  const location = useLocation();

  const dispatch = useDispatch();
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [loading, setLoading] = useState({
    edit: false,
    delete: false,
    listData: false,
    loadingId: "",
  });
  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
  });

  const [contractState, setContractState] = useState({
    currentStep: 1,
    totalStep: 2,
    open: false,
    quotationId: "",
  });

  useEffect(() => {
    const pathSegments = location.pathname.split("/");
    if (pathSegments[3] === "create") {
      setAddOrEdit((p) => ({ ...p, open: true, method: "add", loadedValues: {} }));
      setCostSheetForm((p) => ({ ...p, open: false }));

      dispatch(
        setBreadCrumb([
          { label: "QUOTATION", link: "/dashboard/quotation" },
          { label: "CREATE", link: "" },
        ])
      );
    } else if (pathSegments[3] === "edit-quotation") {
      const editId = pathSegments[4];
      setAddOrEdit((p) => ({
        ...p,
        open: true,
        method: "edit",
        loadedValues: location.state?.loadedValues || p.loadedValues,
        editId: editId,
      }));
      setCostSheetForm((p) => ({ ...p, open: false }));
      dispatch(
        setBreadCrumb([
          { label: "QUOTATION", link: "/dashboard/quotation" },
          { label: "EDIT", link: "" },
        ])
      );
    } else {
      setAddOrEdit((p) => ({ ...p, open: false }));
      setCostSheetForm((p) => ({ ...p, open: false }));
    }
  }, [location]);

  const submitForm = async (
    event,
    client,
    company,
    sector,
    source,
    quotType,
    hourType,
    name,
    status,
    rejectedReason,
    date,
    rejectedDate,
    editing
  ) => {
    event.preventDefault();
    setSubmitFormLoading(true);
    try {
      let response;
      let body;
      if (quotType == 3) {
        body = {
          name,
          client_id: client,
          company_id: company,
          sector_id: sector,
          source_id: source,
          quotation_type_id: quotType,
          hour_type: Number(hourType),
        };
      } else {
        body = {
          name,
          client_id: client,
          company_id: company,
          sector_id: sector,
          source_id: source,
          quotation_type_id: quotType,
        };
      }
      if (status === "Rejected") {
        body.rejected_reason = rejectedReason;
      }

      if (addOrEdit.method === "add") {
        response = await axios.post(`/dashboard/quotation`, body, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else if (addOrEdit.method === "edit") {
        let bodyObj;
        if (status) {
          bodyObj = { ...body, status: status };
        } else {
          bodyObj = { ...body };
        }
        // if (status === "Approved") {
        //   bodyObj.approved_date = date.transformed;
        // } else if (status === "Rejected") {
        //   bodyObj.rejected_date = rejectedDate.transformed;
        // }
        response = await axios.put(
          `/dashboard/quotation/${addOrEdit.editId}`,
          bodyObj,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      }
      const data = response.data.data;
      if (data) {
        navigate("/dashboard/quotation");
        dispatch(getQuotationData(token));
        dispatch(
          setAppError({
            msg: response.data.message,
            color: "bg-green-700",
          })
        );
        setSubmitFormLoading(false);
        setAddOrEdit((p) => ({ ...p, open: false }));
      }
    } catch (err) {
      printValidationError(err, "quotation");
      setSubmitFormLoading(false);

      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };
  const cancelForm = () => {
    navigate("/dashboard/quotation");
    setAddOrEdit((p) => ({ ...p, open: false }));
  };
  const editData = async (id) => {
    navigate(`/dashboard/quotation/edit-quotation/${id}`);

    if (id) {
      setLoading((p) => ({ ...p, edit: true, loadingId: id }));
      try {
        const response = await axios.get(`/dashboard/quotation/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = response.data.data;
        setLoading((p) => ({ ...p, edit: false, loadingId: "" }));
        setAddOrEdit((p) => ({
          ...p,
          open: true,
          method: "edit",
          loadedValues: data,
          editId: id,
        }));
      } catch (err) {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      }
    }
  };
  const deleteData = async (id) => {
    if (id) {
      setLoading((p) => ({ ...p, delete: true, loadingId: id }));
      const QToken = localStorage.getItem("nodeToken");
      try {
        const response = await nodeinstance.delete(
          `/dashboard/quotation/${id}`,
          {
            headers: { Authorization: `Bearer ${QToken}` },
          }
        );
        if (response.status === 200) {
          setLoading((p) => ({ ...p, delete: false, loadingId: "" }));
          dispatch(getQuotationData(token));
          dispatch(
            setAppError({
              msg: response.data.message,
              color: "bg-green-700",
            })
          );
        }
      } catch (err) {
        setLoading((p) => ({ ...p, delete: false }));
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
        if (err?.response?.status === 403) {
          if (err?.response?.data?.message) {
            dispatch(
              setAppError({
                msg: err?.response?.data.message,
              })
            );
          }
        }
      }
    }
  };

  const addData = () => {
    setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
  };

  const [costSheetForm, setCostSheetForm] = useState({
    open: false,
    quotationId: null,
    method: null,
  });
  const showCostSheetWindowHandler = (id, method) => {
    setCostSheetForm((p) => ({
      ...p,
      open: true,
      quotationId: id,
      method: method,
    }));
  };

  const dashboardData = useSelector((state) => state.dashboardData);

  const checkAccess = (module, name) => {
    return checkAccessFn(dashboardData, module, name);
  };

  const [showContractPopup, setShowContractPopup] = useState({
    open: false,
    state: {},
  });

  const contractModalHandler = (
    quotationId,
    quotationNumber,
    quotationName
  ) => {
    // setContractState((p) => ({
    //   ...p,
    //   open: true,
    //   currentStep: 1,
    //   quotationId: quotationId,
    // }));
    setShowContractPopup({
      open: true,
      state: { quotationId, quotationNumber, quotationName },
    });
  };

  const isCreateMode = location.pathname.endsWith("/quotation/create");
  const isEditMode = location.pathname.includes("quotation/edit-quotation");

  return (
    <>
      {showPromptElement.open && (
        <PromptElement
          showPromptElement={showPromptElement}
          setShowPromptElement={setShowPromptElement}
          deleteHandler={deleteData}
        />
      )}
      {/* {contractState.open && (
        <ContractModalElement
          showPromptElement={contractState}
          setShowPromptElement={setContractState}
          contractModalHandler={contractModalHandler}
        />
      )} */}
      {showContractPopup && (
        <QuotationToContract
          showPopup={showContractPopup}
          setShowPopup={setShowContractPopup}
        />
      )}

      <div className="p-2  sm:p-5 ">
        {!addOrEdit.open && !costSheetForm.open && (
          <>
            {quotationData?.data ? (
              <ListDataQuotation
                list={quotationData}
                editData={editData}
                deleteData={setShowPromptElement}
                loading={loading}
                titles={[
                  "S.No.",
                  "Quotation no.",
                  "Name",
                  "Client Name",
                  "Quotation type",
                  "Status",
                  "Cost Sheet",
                  "Created By",
                  "Created Date",
                  "Contract",
                  "Action",
                ]}
                showCostSheetWindowHandler={showCostSheetWindowHandler}
                contractModalHandler={contractModalHandler}
                addData={
                  checkAccess("Quotation", "quotation-create")
                    ? addData
                    : undefined
                }
              />
            ) : quotationData?.error ? (
              <div className="flex flex-col items-center justify-center h-96 gap-4">
                <p className="text-red text-lg font-semibold">
                  {quotationData.error}
                </p>
                <button
                  className="p-2 px-4 bg-blue text-white rounded-md hover:bg-blue/90"
                  onClick={() => dispatch(getQuotationData(token))}
                >
                  Retry
                </button>
              </div>
            ) : (
              <LoadingWithLable />
            )}
          </>
        )}
        {addOrEdit.open && (
          <QuotationForm
            submitForm={submitForm}
            cancelForm={cancelForm}
            submitFormLoading={submitFormLoading}
            loadedValues={addOrEdit.method === "edit" && addOrEdit.loadedValues}
            editing={addOrEdit.method === "edit"}
          />
        )}
      </div>
    </>
  );
}
